import { Button, Space } from "antd";
import LockIcon2 from "../../assets/icons/LockIcon2";
import useModal from "../../hooks/useModal";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";
import SuccessfulModal from "./SuccessfulModal";

export default function ConfirmPasswordResetModal({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps) {
  const { open, handleOpen, handleClose: handleNestedModalClose } = useModal();

  return (
    <CustomModal {...rest} handleClose={handleClose} width={400} footer={null}>
      <div className="flex items-center gap-2">
        <span className="bg-[#FFF5F4] p-1 rounded">
          <LockIcon2 />
        </span>
        <span className="text-[22px] font-semibold">
          Confirm Password Reset!
        </span>
      </div>
      <div className="my-2 text-[#5E718D] mt-4">
        Are you sure you want to reset the password for{" "}
        <span className="text-primary">sBusiness</span>? This action will
        generate a new password and notify the user.
      </div>

      <Space className="w-full mt-4" size={12}>
        <Button
          className="normal-dark-button modal-button"
          onClick={handleClose}
          size="middle"
        >
          Cancel
        </Button>
        <Button
          className="modal-button"
          type="primary"
          htmlType="submit"
          size="middle"
          onClick={() => handleOpen({ type: "VIEW" })}
        >
          Yes, Reset
        </Button>
      </Space>

      {open.type === "VIEW" && (
        <SuccessfulModal
          open={open.open}
          handleClose={handleNestedModalClose}
        />
      )}
    </CustomModal>
  );
}
